const FreedomPossible = () => (
    <section id="freedom-possible">
        <div className="container-fluid py-4 text-center">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-8 col-lg-6 col-11">
                    <p>
                        And if you’re reading this, I want you to know:<br />
                        <b>That kind of freedom is possible.</b><br />
                        Not years from now. Not in theory.
                    </p>
                    <p>But here. Now.</p>
                    <p>So the real question isn’t <i>“Can you eat pancakes again?”</i></p>
                    <p>
                        It’s:<br />
                        <b><i>What if type 2 diabetes isn’t about what you’re eating...<br />
                        but about what your body can’t do anymore because of something no one ever told you about?</i></b>
                    </p>
                    <p>Stick with me.</p>
                    <p>I’ll show you the truth they’ve kept hidden, and the surprising reason everything you’ve tried hasn’t worked.</p>
                </div>
            </div>
        </div>
    </section>
);

export default FreedomPossible;